import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Spring } from 'react-spring';

import animations from 'app/constants/animations';

import textBlockBgImage from 'app/images/text-block-bg.png';
import strings from 'app/locales/results';

import Selectors from 'app/redux/ui/results/selectors';
import { Actions } from 'app/redux/ui/results/actions';

import ResultsLoader from 'app/components/ResultsLoader';
import ResultsContainer from 'app/components/ResultsContainer';
import TextBlock from 'app/components/TextBlock';

import styles from './styles.css';

class Results extends PureComponent {
  state = {
    hasPassedTimeout: false,
    isShowingLoader: true,
  };

  componentDidMount() {
    const { initialize } = this.props;

    initialize();
    this.processLoaderUpdate();
  }

  componentDidUpdate() {
    this.processLoaderUpdate();
  }

  processLoaderUpdate = () => {
    const { isWorking } = this.props;
    const { hasPassedTimeout, isShowingLoader } = this.state;

    if (!isShowingLoader) return;

    if (hasPassedTimeout && !isWorking) {
      this.setState({
        isShowingLoader: false,
      });
    } else {
      setTimeout(() => {
        if (!isWorking) {
          this.setState({
            hasPassedTimeout: true,
            isShowingLoader: false,
          });
        } else {
          this.setState({
            hasPassedTimeout: true,
          });
        }
      }, 3000);
    }
  };

  render() {
    const { assignedResponse, responsePoints } = this.props;
    const { isShowingLoader } = this.state;

    return (
      <div className={styles.container}>
        <Spring
          config={animations.noticeEasing}
          from={
            isShowingLoader ? animations.noticeFrom : animations.noticeEnter
          }
          to={isShowingLoader ? animations.noticeEnter : animations.noticeLeave}
        >
          {styles => (
            <div className={styles.noticeContainer} style={styles}>
              <ResultsLoader text={strings.loaderText} />
            </div>
          )}
        </Spring>
        {!isShowingLoader && (
          <div className={styles.contentContainer}>
            <ResultsContainer
              assignedResponse={assignedResponse}
              responsePoints={responsePoints}
            />
            <TextBlock image={textBlockBgImage} copy={strings.breakUp} />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  initialize: () => dispatch(Actions.initialize()),
});

export default connect(
  Selectors,
  mapDispatchToProps
)(Results);



// WEBPACK FOOTER //
// ./src/routes/Results/index.js